import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';

import { EditSvg as EditIcon, View } from '../../../shared/Assets/svgIcons';

import { DispatchProperties } from '../../../redux/store';
import { clearErrors } from '../../../redux/State/clientSlice/soapNoteSlice';
import { SoapNotesFullProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';
import { clearSessionInfo } from '../../../redux/State/clientSlice/sessionSlice';
import { PEARL } from '../../../shared/Helpers/colors';

const Edit: FC<{
	data: SoapNotesFullProperties;
	isPostSubmit?: boolean;
	isViewOnly: boolean;
}> = ({ data, isViewOnly, isPostSubmit = false }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch<DispatchProperties>();

	const { id, client, sessionId } = data;

	const navigateSoapNoteHandler = () => {
		dispatch(clearErrors());
		dispatch(clearSessionInfo());
		const query = new URLSearchParams();
		query.set('reportId', id);
		query.set('sessionId', sessionId);
		query.set('clientId', client.id);
		query.set('postSubmit', `${isPostSubmit}`);
		navigate(`/soap-notes/edit?${query.toString()}`);
	};

	const tooltipTitle = isPostSubmit ? 'Edit Submitted' : isViewOnly ? 'View' : 'Edit';

	return (
		<Tooltip title={tooltipTitle}>
			<div onClick={navigateSoapNoteHandler} style={{ height: '20px' }}>
				{isViewOnly ? <View /> : <EditIcon color={PEARL.BASE[600]} />}
			</div>
		</Tooltip>
	);
};

export default Edit;
